const courseOne = {
  instructors: [
    {
      id: '185939614',
      coursesTaught: 43,
      department: '',
      fullName: 'Professionals from the Industry',
      isTopInstructor: null,
      learnersReached: 13389,
      photo:
        'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/https://coursera-instructor-photos.s3.amazonaws.com/83/b4728947fa4257a6dcdd56b36db0b1/Screenshot-2025-06-25-at-2.41.43-PM-1-.jpg',
      shortName: '',
      title: '',
      website: null,
    },
  ],
  material: {
    weeks: [
      {
        lectures: [
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
        ],
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT5H11M1S',
        name: 'Data Connectivity With Power BI',
      },
      {
        lectures: [
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
        ],
        assessments: [
          {
            typeName: 'PLUGIN',
          },
          {
            typeName: 'UNGRADED_LAB',
          },
          {
            typeName: 'UNGRADED_LAB',
          },
          {
            typeName: 'UNGRADED_LAB',
          },
          {
            typeName: 'UNGRADED_LAB',
          },
          {
            typeName: 'UNGRADED_LAB',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT5H46M5S',
        name: 'Clean Your Data',
      },
      {
        lectures: [
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
        ],
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT1H40M5S',
        name: 'Verify and Report on Cleaning Results',
      },
      {
        lectures: [
          {
            partners: [
              {
                id: '53',
                name: 'University of California San Diego',
                squareLogo:
                  'https://coursera-university-assets.s3.amazonaws.com/4b/a551cb6e1307836a21059a79e7ae70/UCSanDiego-Coursera-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '53',
                name: 'University of California San Diego',
                squareLogo:
                  'https://coursera-university-assets.s3.amazonaws.com/4b/a551cb6e1307836a21059a79e7ae70/UCSanDiego-Coursera-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '53',
                name: 'University of California San Diego',
                squareLogo:
                  'https://coursera-university-assets.s3.amazonaws.com/4b/a551cb6e1307836a21059a79e7ae70/UCSanDiego-Coursera-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '53',
                name: 'University of California San Diego',
                squareLogo:
                  'https://coursera-university-assets.s3.amazonaws.com/4b/a551cb6e1307836a21059a79e7ae70/UCSanDiego-Coursera-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '53',
                name: 'University of California San Diego',
                squareLogo:
                  'https://coursera-university-assets.s3.amazonaws.com/4b/a551cb6e1307836a21059a79e7ae70/UCSanDiego-Coursera-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '53',
                name: 'University of California San Diego',
                squareLogo:
                  'https://coursera-university-assets.s3.amazonaws.com/4b/a551cb6e1307836a21059a79e7ae70/UCSanDiego-Coursera-square.png',
              },
            ],
          },
        ],
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT1H11M45S',
        name: 'Reading Data in Python',
      },
      {
        lectures: null,
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT1H',
        name: 'Skill Assessment',
      },
    ],
    totalDuration: 'PT14H48M56S',
  },
  id: 'm3xrCoMGEfCzbgr_1h6UfQ',
  slug: 'verified-skill-org-319b8a58-3ec5-4f42-ab3c-0c99c7ba5347',
};

const courseTwo = {
  instructors: [
    {
      id: '185939614',
      coursesTaught: 43,
      department: '',
      fullName: 'Professionals from the Industry',
      isTopInstructor: null,
      learnersReached: 13389,
      photo:
        'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/https://coursera-instructor-photos.s3.amazonaws.com/83/b4728947fa4257a6dcdd56b36db0b1/Screenshot-2025-06-25-at-2.41.43-PM-1-.jpg',
      shortName: '',
      title: '',
      website: null,
    },
  ],
  material: {
    weeks: [
      {
        lectures: [
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '463',
                name: 'Google',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/4a/cb36835ae3421187080898a7ecc11d/Google-G_360x360.png',
              },
            ],
          },
        ],
        assessments: [
          {
            typeName: 'PLUGIN',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT3H29M19S',
        name: ' Data Types and Structures',
      },
      {
        lectures: [
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
        ],
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT3H5M20S',
        name: 'Introduction to (Exploratory Data Analysis) EDA',
      },
      {
        lectures: [
          {
            partners: [
              {
                id: '348',
                name: 'IBM',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/bb/f5ced2bdd4437aa79f00eb1bf7fbf0/IBM-Logo-Blk---Square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '348',
                name: 'IBM',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/bb/f5ced2bdd4437aa79f00eb1bf7fbf0/IBM-Logo-Blk---Square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '348',
                name: 'IBM',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/bb/f5ced2bdd4437aa79f00eb1bf7fbf0/IBM-Logo-Blk---Square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '348',
                name: 'IBM',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/bb/f5ced2bdd4437aa79f00eb1bf7fbf0/IBM-Logo-Blk---Square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '348',
                name: 'IBM',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/bb/f5ced2bdd4437aa79f00eb1bf7fbf0/IBM-Logo-Blk---Square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '348',
                name: 'IBM',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/bb/f5ced2bdd4437aa79f00eb1bf7fbf0/IBM-Logo-Blk---Square.png',
              },
            ],
          },
        ],
        assessments: [
          {
            typeName: 'PLUGIN',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT49M47S',
        name: 'Data Wrangling',
      },
      {
        lectures: [
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
        ],
        assessments: [
          {
            typeName: 'PLUGIN',
          },
        ],
        totalDuration: 'PT1H20M30S',
        name: 'Pandas',
      },
      {
        lectures: null,
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT1H',
        name: 'Skill Assessment',
      },
    ],
    totalDuration: 'PT9H44M56S',
  },
  id: '2UZJxYMGEfCEdA4CIsVNww',
  slug: 'verified-skill-org-efe2edc4-880f-4491-b61b-2dc801900008',
};

const courseThree = {
  instructors: [
    {
      id: '185939614',
      coursesTaught: 43,
      department: '',
      fullName: 'Professionals from the Industry',
      isTopInstructor: null,
      learnersReached: 13389,
      photo:
        'https://d3njjcbhbojbot.cloudfront.net/api/utilities/v1/imageproxy/https://coursera-instructor-photos.s3.amazonaws.com/83/b4728947fa4257a6dcdd56b36db0b1/Screenshot-2025-06-25-at-2.41.43-PM-1-.jpg',
      shortName: '',
      title: '',
      website: null,
    },
  ],
  material: {
    weeks: [
      {
        lectures: [
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
        ],
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT1H23M34S',
        name: 'Data and Information',
      },
      {
        lectures: [
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1734',
                name: 'Packt',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/3b9b5304c24cf4aa64054631ee946c/360-360-square.png',
              },
            ],
          },
        ],
        assessments: null,
        totalDuration: 'PT36M47S',
        name: 'GroupBy',
      },
      {
        lectures: [
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
        ],
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT3H5M20S',
        name: 'Introduction to (Exploratory Data Analysis) EDA',
      },
      {
        lectures: [
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
          {
            partners: [
              {
                id: '1504',
                name: 'Edureka',
                squareLogo:
                  'http://coursera-university-assets.s3.amazonaws.com/fa/c802562af74829972ac7261a021358/Square-Logo-for-Partner-Landing-Page.png',
              },
            ],
          },
        ],
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT5H1M1S',
        name: 'Data Connectivity with Power BI',
      },
      {
        lectures: null,
        assessments: [
          {
            typeName: 'ASSIGNMENT',
          },
        ],
        totalDuration: 'PT1H',
        name: 'Skill Assessment',
      },
    ],
    totalDuration: 'PT11H6M42S',
  },
  id: '_84GuoMGEfC2OhKwGgKtJw',
  slug: 'verified-skill-org-5496f638-ecd2-4c47-8ddf-3ae5f97e9e46',
};

export const mockVspPageQueryData = [courseOne, courseTwo, courseThree];
